import { useState } from "react"
import { Form } from "antd"

export const useParentForm = () => {
  const [selected, setSelected] = useState(null)
  const [parentData, setParentData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    dob: null,
    phone: null
  })
  
  const form = Form.useForm()[0]

  const handlePhoneChange = (value) => {
    setParentData(prev => ({ ...prev, phone: value }))
  }

  const handleSelectionChange = (selection) => {
    setSelected(selection)
  }

  return {
    selected,
    setSelected: handleSelectionChange,
    parentData,
    setParentData,
    form,
    handlePhoneChange
  }
}
